import { Chart } from 'primereact/chart';
import React, { useEffect, useState } from 'react';
import { metricValueFormat, metricValueFormatWithoutUnit } from '../../../utils/metricValueFormat';
import { Numbers } from '../../../utils/typeConstants';
import { MetricColors } from '../../../components/metricMonthlySummaryCard/GradientDefs';

interface FollowUpPeriodResultProps {
    dailyData: any;
    metricIndex: number;
}

export const FollowUpPeriodResult = ({
    dailyData,
    metricIndex,
}: FollowUpPeriodResultProps) => {
    const [basicData, setBasicData] = useState<any>();
    const [textColor, setTextColor] = useState('#000000');
    const [selectedMetricBackgrndColor, setSelectedMetricBackgrndColor] = useState('#FFFFFF');


    const basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: 2.0,
        interaction: {
            mode: 'nearest',
            intersect: false,
        },
        plugins: {
            legend: { display: false },

            tooltip: {
                enabled: true,
                position: 'nearest',
                callbacks: {
                    label: (ctx: any) => {
                        if (ctx.dataset.label === 'Target') {
                            return `Target: ${ctx.formattedValue}%`;
                        }
                        return ctx.formattedValue;
                    },
                },
            },
        },
        scales: {
            x: {
                display: true,
                min: 0,
                ticks: {
                    color: '#495057',
                },
                grid: {
                    display: false,
                },
            },
            y: {
                type: 'linear',
                color: textColor,
                display: true,
                position: 'left',
                grid: {
                    display: false,
                },
                title: {
                    text: `Target : ${metricValueFormat(dailyData?.[0]?.target, dailyData?.[0]?.metric_type_name)}`,
                    color: textColor,
                    font: {
                        size: 14,
                        weight: 'bold',
                    },
                },
            },
        },
    };

    function zeroTest(element: any) {
        return element === 0;
    }

    useEffect(() => {
        const getBarColor = (metricAttained: any) => {
            const colorIndex = metricIndex;
            const colors = MetricColors[colorIndex];
            setTextColor(colors.textColor);
            setSelectedMetricBackgrndColor(colors.bgColor);
            return metricAttained === 1 || metricAttained === true ? colors.metricMet : colors.metricNotMet;
        };

        const colorIndex = metricIndex;
        const currentTextColor = MetricColors[colorIndex].textColor;

        if (dailyData?.length > 0) {
            const reversedData = dailyData?.slice().reverse();
            const metricValues = reversedData.map((item: any) => {
                return metricValueFormatWithoutUnit(item?.metric_value, item?.metric_type_name);
            });

            setBasicData({
                labels: reversedData?.map((item: any) => {
                    const resultDate = new Date(item.result_date);
                    return `${resultDate.getDate()}-${resultDate.toLocaleString('en-US', {
                        month: 'short',
                    })}`;
                }),
                datasets: [
                    {
                        data: new Array(reversedData?.length).fill(
                            metricValueFormatWithoutUnit(Number(dailyData?.[0]?.target), dailyData?.[0]?.metric_type_name)
                        ),
                        type: 'line',
                        label: 'Target',
                        borderColor: currentTextColor,
                        borderWidth: 2,
                        borderDash: [5, 5],
                        pointRadius: 0,
                        resultDate: reversedData?.map((item: any) => item.result_date),
                        datalabels: {
                            display: false,
                        },
                    },
                    {
                        data: metricValues,
                        fill: false,
                        backgroundColor: reversedData?.map((item: any) => getBarColor(item.metric_attained)),
                        borderWidth: Numbers.ONE,
                        borderRadius: Numbers.FIVE,
                        // datalabels: {
                        //     color: '#FFFFFF',
                        //     anchor(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 'end' : 'start';
                        //     },
                        //     align(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 'start' : 'end';
                        //     },
                        //     offset(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 5 : -10;
                        //     },
                        //     font: {
                        //         weight: 'bold',
                        //         size: 12,
                        //     },
                        // },
                        datalabels: {
                            display: false,
                        },
                    },
                ],
            });
        } else {
            setBasicData({
                labels: [],
                datasets: [
                    {
                        data: [],
                        type: 'line',
                        label: 'Target',
                        borderColor: currentTextColor,
                        borderWidth: 2,
                        borderDash: [5, 5],
                        pointRadius: 0,
                        datalabels: {
                            display: false,
                        },
                    },
                    {
                        data: [],
                        fill: false,
                        backgroundColor: [],
                        borderWidth: Numbers.ONE,
                        borderRadius: Numbers.FIVE,
                        // datalabels: {
                        //     color: '#FFFFFF',
                        //     anchor(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 'end' : 'start';
                        //     },
                        //     align(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 'start' : 'end';
                        //     },
                        //     offset(context: any) {
                        //         const value = context.dataset.data[context.dataIndex];
                        //         return value > 0 ? 5 : -10;
                        //     },
                        //     font: {
                        //         weight: 'bold',
                        //         size: 12,
                        //     },
                        // },
                        datalabels: {
                            display: false,
                        },
                    },
                ],
            });
        }
    }, [dailyData]);

    return (
        <div className="col">
            <div className="h-100">
                <div className="card-body" style={{ backgroundColor: selectedMetricBackgrndColor, borderLeft: `1px solid #e0e4f0` }}>
                    <div className="row d-flex flex-wrap">
                        <div className="container mt-2">
                            {basicData?.datasets[1]?.data.every(zeroTest) ? (
                                <div className="border-0">
                                    <div className="align-middle text-center">
                                        <div className="row" style={{ height: '170px' }}>
                                            <div className="col-md-12" style={{ margin: 'auto' }}>
                                                <p className="align-middle">No Data Found</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Chart type="bar" data={basicData} options={basicOptions} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
